export default "__VITE_ASSET__DGkoZIkA__"